export default "__VITE_ASSET__d6fb06e5__"